<template>
  <div class="content_404">
    <a-row class="div_content">
      <a-col class="icon_404"></a-col>
      <a-col class="content_desc">
        <div class="item_bold">Dear valued user,</div>
        <div><br>
          Thank you for your interest in Printbelle. Currently, our system is not available in
          mainland China. We appreciate your understanding and patience. Please note that we are exploring possibilities to expand to your region in the future.
          <br><br>
          If you have urgent cooperation needs or inquiries, please feel free to contact us at <a href="mailto:sale@printbelle.com" class="item_email">sale@printbelle.com</a>.
          <br><br>
          Thank you for your understanding.
          <br><br>
        </div>
        <div class="item_bold">Best regards,<br>The Printbelle Team</div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Exception404',
  methods: {
    toHome () {
      window.location.href = '/'
    }
  }
}
</script>
<style scoped type="less">
.content_404 {
  background-image: url(../../assets/404_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;

  .div_content {
    display: flex;
    flex-direction: column;
    padding-top: 126px;
    align-items: center;
    justify-items: center;

    .icon_404 {
      background-image: url(../../assets/404_icon.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 579px;
      height: 280px;
    }
    .content_desc{
      width: 577px;
      margin-top: 60px;
      font-family: Roboto;
      font-size: 16px;
      color: #485256;

      .item_bold {
        font-weight: bold;
      }
      .item_email {
        color: #343084;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exception/404.vue